<template lang="html">
  <div>
    <div class="intd_header_top">
      <van-nav-bar
        title="积分商城"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="intd_content">
      <div class="intd_desc">
        <div class="img_box">
          <img :src="`http://bbs.jmgo.com/${IntDetailsData.img_url}`" alt="">
        </div>
        <div class="right_desc">
          <ul>
            <li>{{IntDetailsData.name}}</li>
            <li>市场价：{{IntDetailsData.real_price}}元</li>
            <li>兑换：{{IntDetailsData.ext_price}}果实</li>
            <li>数量：{{IntDetailsData.number}}</li>
          </ul>
        </div>
      </div>
      <div class="time_box">
        <p>开始时间：{{IntDetailsData.starttimefrom}}</p>
        <p>结束时间：{{IntDetailsData.starttimeto}}</p>
        <p>剩余时间：<span >{{restTime}}</span></p>
      </div>
      <div class="int_tab_container">
        <van-tabs v-model="active">
          <van-tab title="详情">
            <div class="left_content">
              <div class="int_detail_content">
                <p class="content_msg" v-html="intDetail.message"></p>
              </div>

            </div>
          </van-tab>
          <van-tab title="评论">
            <div class="right_content">
              <ul>
                <li v-for="(item, index) in intCommentList" :key="index">
                  <div class="right_cont_left">
                    <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${item.authorid}&size=middle`" alt="">
                  </div>
                  <div class="right_cont_right">
                    <h2>{{item.author}}</h2><span v-html="item.dateline"></span>
                    <div class="quote" v-html="item.message">
                      
                    </div>
                  </div>
                </li>
              </ul>
              <span class="loadMores" @click="getIntLoadMoreData" v-show="resData.totalpage != null">{{loadMoresTxt}}</span>
              <div class="comment_box">
                <input class="com_input" v-model="commendMsg" type="text" name="" value="" placeholder="写评论...">
                <span class="subimt" @click="subimtCommendMsg">发布</span>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <span class="int_bottom_btn" @click="toRedeem">立即兑换</span>
        <van-popup v-model="show" :close-on-click-overlay="false">
          <div class="model_comtent">
            <span @click="p_close">X</span>
            <p class="p_content">{{duihuan}}</p>
            <input class="input_content" v-model="duihuanmagess" type="hidden" name="">
            <input class="input_content" v-model="mobile" type="text" name="mobile" placeholder="请填写手机号">
            <input class="input_content" v-model="address" type="text" name="address" placeholder="请填写收货地址">
            <van-button type="danger" size="large" @click="immediatelyExchange">确定</van-button>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { NavBar } from 'vant'
import { Tab, Tabs } from 'vant'
import { Popup } from 'vant'
import { Button } from 'vant'
import { Toast } from 'vant'

Vue.use(Toast)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Tab).use(Tabs)
Vue.use(NavBar)
export default {
  data (){
    return{
      active: 0,
      IntDetailsData: {},
      intPage: [],
      intDetail: [],
      intCommentList: [],
      restTime:'',
      pages: 1,
      resData: [],
      commendMsg: '',
      show: false,
      duihuan: [],
      duihuanmagess: '',
      formhash: '',
      mobile: '',
      address:'',
      uid:'',
      loadMoresTxt: '点击加载更多...'
    }
  },
  mounted() {
    this.getIntDetailsData()
    this.getIntDetails()

  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getIntDetailsData() {
      utilAxios.get({
        url: '/new_api.php?module=auction&act=viewthread&tid='+this.$route.params.tid,
        method: 'GET',
        callback: (res) => {
          if(res.data.code == 100) {
            if(res.data.mobile==''){
              window.location.href='/forum.php?mod=viewthread&ordertype=1&tid='+ this.$route.params.tid+'&page=1'
            }
            this.IntDetailsData = res.data.data
            this.formhash=res.data.formhash

            this.getRestTime()
          }
        }
      })
    },
    getRestTime(){
      let rest_time=parseInt(this.IntDetailsData.starttimeto_0)-parseInt(this.IntDetailsData.js_timenow);
      let that=this;
      let time=window.setInterval(function(){
        that.restTime=countDown(rest_time);
        
        rest_time-=1;
        if(rest_time<=0){
          window.clearInterval(time)
        }
      }, 1000);
      
      

    },
    p_close(){
      this.show=false;
    },
    // ----获取详情和评论数据-----
    getIntDetails() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=viewthread&tid='+ this.$route.params.tid+'&page=' + this.pages,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.intDetail = res.data.post_content
            this.intCommentList = res.data.postlist
            this.resData = res.data
            this.uid=res.data.uid
          }
        }
      })
    },
    getIntLoadMoreData() {
      this.pages = this.pages + 1
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=viewthread&tid='+ this.$route.params.tid+'&page=' + this.pages,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            if(res.data.page <= res.data.totalpage){
              for(let i in res.data.postlist) {
                this.intCommentList.push(res.data.postlist[i])
              }
            }else{
              this.loadMoresTxt = '没有更多内容了...'
            }
          }else if (res.data.code == 300) {
            this.loadMoresTxt = res.data.msg
          }
        }
      })
    },

    /*-----文章评论-------*/
    subimtCommendMsg() {
      if (!this.uid || this.uid=='0') {
        location.href = 'https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act='+escape('http://bbs.jmgo.com/dist/#/intDetails/'+this.$route.params.tid);
      }
      let params={
        replysubmit:'replysubmit',
          formhash: this.formhash,
          message: this.commendMsg,
          usesig: this.resData.uid,
          posttime: Date.parse( new Date())/1000,
      }
      utilAxios.formpost({
        url: '/new_api.php?module=forum&mod=post&action=reply&replaysubmit=yes&fid='+ this.resData.fid +'&tid='+this.$route.params.tid,
        method: 'POST',
        data: Qs.stringify(params),
        callback: (res) => {
          console.log(res)
          if (res.data.code == 100) {
            this.getIntDetails() 
            Toast.success(res.data.msg)
          } else {
            Toast.fail(res.data.msg)
          }
        }
      })
    },

    // -----积分兑换检查------
    toRedeem() {
       if (!this.uid || this.uid=='0') {
        location.href = 'https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act='+escape('http://bbs.jmgo.com/dist/#/intDetails/'+this.$route.params.tid);
      }
      utilAxios.get({
        url: '/new_api.php?module=involve&operation=join&tid='+ this.$route.params.tid +'&infloat=yes&handlekey=confirm&inajax=1&ajaxtarget=fwin_content_confirm',
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.show = true
            this.duihuan = res.data.m_type1_tips_p
            this.duihuanmagess = res.data.reply_message
            this.formhash = res.data.formhash
            this.mobile = res.data.mobile
          }else if(res.data.code == 300){
            Toast(res.data.msg)
          }
        }
      })
    },
    // -----积分兑换------
    immediatelyExchange() {
      if (!this.uid || this.uid=='0') {
        location.href = 'https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act='+escape('http://bbs.jmgo.com/dist/#/intDetails/'+this.$route.params.tid);
      }
      const data = Qs.stringify({"formhash": this.formhash,"auc_reply_message": this.duihuanmagess,"confirmsubmit": true,"mobile": this.mobile,"address":this.address });
      utilAxios.formpost({
        url: ' /new_api.php?module=involve&tid='+ this.$route.params.tid +'&operation=join',
        method: 'POST',
        data: data,
        callback: (res) => {
          if (res.data.code == 100) {
            this.show = false
            Toast(res.data.msg)
          }else{
            Toast(res.data.msg)
          }
        }
      })
    }
  }
}
function countDown(time){
  var str_time=''
  if(time>0){
    var daysnum=Math.floor(time/(60*60*24));
    var hournum=Math.floor(time/(60*60)-(24*daysnum))
    var minnum=Math.floor(time/60 - (24 * 60 * daysnum) - (60 * hournum))
    var second=Math.floor(time - (24 * 60 * 60 * daysnum) - (60 * 60 * hournum) -(60 * minnum))
    if(hournum<10 && hournum>0){
      hournum='0'+hournum;
    }
    if(minnum<10 && minnum>0){
      minnum='0'+minnum
    }
    if(second<10 && second>0){
      second='0'+second
    }
    str_time=(daysnum?daysnum+" 天 ":'')+ (hournum > 0 ?hournum + " 小时 ":'') + (minnum?minnum + " 分钟 ":'')+ second + " 秒";
  }else{
    str_time='已结束'

  }
  return str_time;
}
</script>
<style>
  .int_detail_content .content_msg img{
    width:100%;
  }
</style>
<style lang="scss" scoped>
  .intd_content{
    margin-top: .46rem;
    .intd_desc{
      width: 100%;
      //height: 1.4rem;
      background: #fff;
      display: flex;
      border-bottom: 1px solid #EEE;
      .img_box{
        width: 1.4rem;
        height: 1.4rem;
        display: flex;
        img{
          width: 100%;
          margin: auto;
        }
      }
      .right_desc{
        flex: 1;
        ul{
          // padding-top: .33rem;
          li{
            //height: .35rem;
            line-height: .35rem;
            padding-left: .2rem;
          }
        }
      }
    }
    .time_box{
      background: #FFF;
      p{
        height: .35rem;
        padding-left: .1rem;
        line-height: .35rem;
        span{
          color: red;
        }
      }
    }
    .int_tab_container{
      margin-top: .05rem;
      .int_bottom_btn{
        position: fixed;
        left: 0;
        bottom: 0;
        background: red;
        width: 100%;
        height: .44rem;
        text-align: center;
        line-height: .44rem;
        color: #fff;
        z-index: 1001
      }
    .left_content{
      width: 100%;
      .int_detail_content{
        padding: .2rem;
        .content_msg{
          font-size: .12rem;
          line-height: .2rem;
          word-break:break-all;
          word-wrap:break-word;
          img{
            width: 100%;
          }
        }
      }
    }
    .right_content{
      width: 100%;
      padding-bottom:1rem;
      overflow:hidden;
      .comment_box{
        height: .35rem;
        background: #FFF;
        display: flex;
        padding: .1rem;
        .com_input{
            flex: 1;
            border: none;
            border: 1px solid #999;
            border-radius: .04rem;
            padding: .05rem;
        }
        .subimt{
          width: .5rem;
          border-radius: .04rem;
          border: 1px solid #999;
          display: inline-block;
          line-height: .35rem;
          color: #999;
          text-align: center;
          margin-left: .1rem;
        }
      }
      ul{
        li{
          padding: .1rem;
          background: #FFF;
          display: flex;
          border-bottom: 1px solid #EEE;
          .right_cont_left{
            width: .9rem;
            img {
              width: .7rem;
              height: .7rem;
              border-radius: 1rem;
            }
          }
          .right_cont_right{
            flex: 1;
            h2{
              font-size: .14rem;
            }
            span{
              display: block;
              padding: .1rem 0;
              color: #888;
            }
            .quote{
              line-height: .15rem;
              word-break:break-all;
              word-wrap:break-word;
            }
          }
        }
      }
    }
  }
}
.loadMores{
  display: block;
  width: 100%;
  height: .4rem;
  text-align: center;
  line-height: .4rem;
}
._bottom_76{
  width: 100%;
  height: .76rem;
}

.model_comtent{
  padding: .2rem;
  position:relative;
  span{
    position:absolute;
    width:16px;
    height:16px;
    text-align:center;
    line-height:16px;
    top:-8px;
    right:-8px;
    background:#f10000;
    color:#fff;
    border-radius:50%;
    display:block;
  }
  .van-button--large {
    width: 100%;
    height: 40px;
    line-height: 38px;
  }
  .p_content{
    font-size: .12rem;
    text-align: left;
    line-height: .15rem;
  }
  .input_content{
    width: 2rem;
    height: .3rem;
    border: none;
    border: 1px solid #eee;
    margin: .1rem 0;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/IntDetails/IntDetails.vue